/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1ExamRevisionQuestionQuestionidMutationResponse,
  DeleteApiV1ExamRevisionQuestionQuestionidPathParams,
  DeleteApiV1ExamRevisionQuestionQuestionid400,
  DeleteApiV1ExamRevisionQuestionQuestionid401,
  DeleteApiV1ExamRevisionQuestionQuestionid500,
} from "../../types/examRevisionController/DeleteApiV1ExamRevisionQuestionQuestionid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1ExamRevisionQuestionQuestionid } from "../../clients/examRevisionController/deleteApiV1ExamRevisionQuestionQuestionid.ts";

export const deleteApiV1ExamRevisionQuestionQuestionidMutationKey = () =>
  [{ url: "/api/v1/exam/revision/question/:questionId" }] as const;

export type DeleteApiV1ExamRevisionQuestionQuestionidMutationKey = ReturnType<
  typeof deleteApiV1ExamRevisionQuestionQuestionidMutationKey
>;

export function deleteApiV1ExamRevisionQuestionQuestionidMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = deleteApiV1ExamRevisionQuestionQuestionidMutationKey();
  return mutationOptions<
    DeleteApiV1ExamRevisionQuestionQuestionidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ExamRevisionQuestionQuestionid400
      | DeleteApiV1ExamRevisionQuestionQuestionid401
      | DeleteApiV1ExamRevisionQuestionQuestionid500
    >,
    {
      questionId: DeleteApiV1ExamRevisionQuestionQuestionidPathParams["questionId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ questionId }) => {
      return deleteApiV1ExamRevisionQuestionQuestionid(questionId, config);
    },
  });
}

/**
 * @description Remove uma questão de prova gerada por IA pelo identificador informado. Se a questão não for encontrada, a operação é concluída silenciosamente sem erro. **(Requer Authorization para autenticação)**
 * @summary Excluir questão da prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/question/:questionId}
 */
export function useDeleteApiV1ExamRevisionQuestionQuestionid<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1ExamRevisionQuestionQuestionidMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1ExamRevisionQuestionQuestionid400
        | DeleteApiV1ExamRevisionQuestionQuestionid401
        | DeleteApiV1ExamRevisionQuestionQuestionid500
      >,
      {
        questionId: DeleteApiV1ExamRevisionQuestionQuestionidPathParams["questionId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiV1ExamRevisionQuestionQuestionidMutationKey();

  const baseOptions = deleteApiV1ExamRevisionQuestionQuestionidMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1ExamRevisionQuestionQuestionidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ExamRevisionQuestionQuestionid400
      | DeleteApiV1ExamRevisionQuestionQuestionid401
      | DeleteApiV1ExamRevisionQuestionQuestionid500
    >,
    {
      questionId: DeleteApiV1ExamRevisionQuestionQuestionidPathParams["questionId"];
    },
    TContext
  >;

  return useMutation<
    DeleteApiV1ExamRevisionQuestionQuestionidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ExamRevisionQuestionQuestionid400
      | DeleteApiV1ExamRevisionQuestionQuestionid401
      | DeleteApiV1ExamRevisionQuestionQuestionid500
    >,
    {
      questionId: DeleteApiV1ExamRevisionQuestionQuestionidPathParams["questionId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1ExamRevisionQuestionQuestionidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ExamRevisionQuestionQuestionid400
      | DeleteApiV1ExamRevisionQuestionQuestionid401
      | DeleteApiV1ExamRevisionQuestionQuestionid500
    >,
    {
      questionId: DeleteApiV1ExamRevisionQuestionQuestionidPathParams["questionId"];
    },
    TContext
  >;
}
